import React from 'react';

// DEPENDENCIES
import { useParams } from 'react-router-dom';

// LOCAL COMPONENTS
import InventoryDetail from './parts/Detail';
import VehicleInfo from '../../sections/VehicleInfo';
import PricingInfo from '../../sections/PricingInfo';
import PurchaseInfo from '../../sections/PurchaseInfo';
import InventoryInternal from '../../sections/InventoryInternal';
import InventoryAttachments from '../../sections/InventoryAttachments';

// MAIN COMPONENT
const InventoryEdit = () => {
  const { recordID } = useParams();
  return (
    <InventoryDetail vehicleId={recordID}>
      <VehicleInfo />
      <PricingInfo />
      <InventoryInternal />
      <PurchaseInfo />
      <InventoryAttachments />
    </InventoryDetail>
  );
};

// EXPORT
export default InventoryEdit;
